import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.842 1.538L15.46 6.92a.94.94 0 0 0 .708.521l5.855.863c.771.114 1.078 1.075.52 1.626l-4.237 4.188a.964.964 0 0 0-.27.844l1 5.914c.132.779-.674 1.373-1.364 1.006l-5.237-2.793a.93.93 0 0 0-.875 0L6.323 21.88c-.69.367-1.495-.226-1.364-1.006l1-5.914a.964.964 0 0 0-.27-.844L1.452 9.93c-.558-.551-.25-1.512.52-1.626l5.854-.863a.94.94 0 0 0 .708-.52l2.618-5.382a.938.938 0 0 1 1.69 0z"
});

var SvgStarFilled = function SvgStarFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgStarFilled;